import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
//import { ConfigProvider } from './contexts/ConfigContext';
import { normalizePath } from './normalizePath'; 

normalizePath();
ModuleRegistry.registerModules([AllCommunityModule]);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/*<ConfigProvider>*/}
      <App />
    {/*</ConfigProvider>*/}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
